import React, { useRef } from "react";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import type { QueryClientConfig } from "@tanstack/react-query";

export interface ReactQueryProviderProps extends React.PropsWithChildren {
  config?: QueryClientConfig;
}

export default function ReactQueryProvider({ children, config }: ReactQueryProviderProps) {
  const queryClientRef = useRef(
    new QueryClient({
      defaultOptions: {
        queries: {
          refetchOnWindowFocus: false,
          retry: false
        }
      },
      ...config
    })
  );
  return <QueryClientProvider client={queryClientRef.current}>{children}</QueryClientProvider>;
}
